import { platformCards } from "@/mocks/home";
import Reveal from "@/pages/home/components/Reveal";

export default function EntryCards() {
  return (
    <section id="entry" className="w-full bg-background-100 py-16 md:py-24 border-y border-background-200">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-8">
        <Reveal>
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
            <div>
              <span className="text-xs tracking-widest text-accent-700 uppercase">Download Entries</span>
              <h2 className="mt-3 font-heading text-2xl md:text-3xl text-foreground-950">按设备选版本，入口一次对齐</h2>
            </div>
            <p className="text-sm text-foreground-600 max-w-md leading-relaxed">
              四种版本对应不同使用场景，先看自己手里是什么设备，再决定装哪一种，能少走不少弯路。
            </p>
          </div>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-6">
          {platformCards.map((card, i) => (
            <Reveal key={card.id} delay={i * 80}>
              <article className="h-full rounded-lg overflow-hidden border border-background-200 bg-background-50 flex flex-col">
                <div className="w-full h-48 md:h-52 bg-background-200 overflow-hidden">
                  <img
                    src={card.image}
                    alt={`茄子视频${card.title}示意图`}
                    title={`茄子视频${card.title}下载入口`}
                    className="w-full h-full object-top"
                  />
                </div>

                <div className="p-5 md:p-6 flex flex-col flex-1">
                  <div className="flex items-center gap-3">
                    <span className="text-xs text-foreground-500">{card.platform}</span>
                    <span className="text-xs text-secondary-900 bg-secondary-100 px-2 py-0.5 rounded-full">
                      {card.tag}
                    </span>
                  </div>

                  <h3 className="mt-3 font-heading text-lg text-foreground-950">{card.title}</h3>
                  <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{card.desc}</p>

                  <ul className="mt-4 space-y-2">
                    {card.points.map((point) => (
                      <li key={point} className="flex items-start gap-2 text-xs text-foreground-700">
                        <i className="ri-check-line text-primary-600 mt-0.5"></i>
                        <span>{point}</span>
                      </li>
                    ))}
                  </ul>

                  <a
                    href="#install"
                    className="mt-5 inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-md text-sm border border-primary-300 text-primary-700 hover:bg-primary-500 hover:text-background-50 transition-colors whitespace-nowrap"
                  >
                    查看安装方式
                    <i className="ri-arrow-right-line"></i>
                  </a>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}